import { render, staticRenderFns } from "./ScreenType.vue?vue&type=template&id=454f0efb&scoped=true&"
import script from "./ScreenType.vue?vue&type=script&lang=js&"
export * from "./ScreenType.vue?vue&type=script&lang=js&"
import style0 from "./ScreenType.vue?vue&type=style&index=0&id=454f0efb&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454f0efb",
  null
  
)

export default component.exports